import { isGearboxV3 } from '@1delta/lender-registry'
import type { TermAdapter } from './index'

/**
 * Gearbox V3 — credit accounts over a passive pool.
 *
 * Two specifics: the pool rate is set on the POOL, not the credit manager
 * (so the utilization basis is the pool), and quoted collateral carries a
 * per-collateral QUOTA rate — a borrow-side carrying cost already netted into
 * `intrinsicYield`, which is why it must not be added again here.
 */
export const gearboxAdapter: TermAdapter = {
  id: 'gearbox',
  matches: isGearboxV3,
  profileId: () => 'pool.variable@v1',
  build: () => ({
    utilization: { basis: 'pool' },
    constraints: {
      positionModel: 'sub-account',
      positionIdMeaning: 'The credit-account address opened for this user.',
    },
  }),
}
